import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { t } from "i18next";
import { SmsStatusCode } from "@/types/sms";

/** Design pill variant a status maps to. */

/** Resolved label and pill variant for a message status. */

var STATUS_META = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SmsStatusCode.QUEUED, {
  labelKey: "sms.status.queued",
  labelDefault: "Queued",
  pill: "queued"
}), SmsStatusCode.SENT, {
  labelKey: "sms.status.sent",
  labelDefault: "Sent",
  pill: "delivered"
}), SmsStatusCode.LINK_OPENED, {
  labelKey: "sms.status.link_opened",
  labelDefault: "Link opened",
  pill: "delivered"
}), SmsStatusCode.VERIFIED, {
  labelKey: "sms.status.verified",
  labelDefault: "Verified",
  pill: "delivered"
}), SmsStatusCode.VIEWED, {
  labelKey: "sms.status.viewed",
  labelDefault: "Viewed",
  pill: "viewed"
}), SmsStatusCode.FAILED, {
  labelKey: "sms.status.failed",
  labelDefault: "Failed",
  pill: "failed"
}), SmsStatusCode.OPTED_OUT, {
  labelKey: "sms.status.opted_out",
  labelDefault: "Opted out",
  pill: "muted"
}), SmsStatusCode.EXPIRED, {
  labelKey: "sms.status.expired",
  labelDefault: "Expired",
  pill: "queued"
}), SmsStatusCode.VERIFY_LOCKED, {
  labelKey: "sms.status.verify_locked",
  labelDefault: "Locked",
  pill: "failed"
});

/** Resolves a translated label and pill variant, preferring the server label. */
export function getStatusMeta(status, statusLabel) {
  var entry = STATUS_META[status];
  var meta = entry ? {
    label: t(entry.labelKey, {
      defaultValue: entry.labelDefault
    }),
    pill: entry.pill
  } : {
    label: String(status),
    pill: "muted"
  };
  return statusLabel ? _objectSpread(_objectSpread({}, meta), {}, {
    label: statusLabel
  }) : meta;
}
var PRE_SEND_FAILURE_DEFAULTS = {
  opted_out: "This patient has opted out of SMS. No message can be sent.",
  not_mobile: "The number on file is not a mobile number.",
  outside_window: "Outside the allowed send window (quiet hours) for this patient.",
  template_unavailable: "This template is not available to send.",
  missing_short_link: "This template is missing the secure link (@shortlink). Fix it in template settings.",
  missing_last_name: "This patient has no last name on file, so they couldn't verify their identity. Add a last name to the patient record, then send.",
  provider_error: "The carrier rejected the message. You can retry."
};

/** Resolves a translated, human-friendly message for a 422 pre-send failure reason. */
export function getPreSendFailureMessage(reason) {
  var fallback = PRE_SEND_FAILURE_DEFAULTS[reason];
  return fallback ? t("sms.pre_send_failure.".concat(reason), {
    defaultValue: fallback
  }) : "";
}